(function(){
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var overlay=$('#overlay'), cart=$('#CartDrawer'), mm=$('#MobileMenu');
  function openEl(el){if(el)el.classList.add('open'); if(overlay)overlay.classList.add('open')}
  function closeAll(){$$('.open').forEach(function(e){e.classList.remove('open')})}

  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-open-cart]'); if(o){e.preventDefault();openEl(cart);return}
    var m=e.target.closest('[data-open-menu]'); if(m){e.preventDefault();openEl(mm);return}
    if(e.target.closest('[data-close]')||e.target.id==='overlay'){closeAll();return}
  });

  // sticky header + back-to-top
  var hdr=$('.hdr'), top=$('#toTop');
  window.addEventListener('scroll',function(){
    var y=window.scrollY;
    if(hdr)hdr.classList.toggle('scrolled',y>10);
    if(top)top.classList.toggle('show',y>700);
  });
  if(top)top.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});

  // reveal
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})},{threshold:.1});
    $$('.reveal').forEach(function(el){io.observe(el)});
  }

  // add to cart (ajax) -> refresh drawer
  function money(c){try{return (window.Shopify&&Shopify.currency?Shopify.currency.active+' ':'Rs.')+(c/100).toLocaleString()}catch(e){return 'Rs.'+(c/100)}}
  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var n=cart.item_count;
      $$('[data-cart-count]').forEach(function(el){el.textContent=n; if(el.hasAttribute('data-dot'))el.style.display=n?'grid':'none';});
      var box=$('#CartItems'); var foot=$('#CartFoot');
      if(!box)return;
      if(!cart.items.length){box.innerHTML='<div class="cd-empty"><div style="font-family:Fraunces,serif;font-size:22px;color:var(--ink);margin-bottom:8px">Your bag is empty</div>Add something beautiful.</div>'; if(foot)foot.style.display='none'; return;}
      box.innerHTML=cart.items.map(function(it){
        return '<div class="ci"><img src="'+(it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2'):'')+'" alt=""><div><div class="cat">'+(it.product_type||'')+'</div><h5>'+it.product_title+'</h5>'+(it.variant_title&&it.variant_title!=='Default Title'?'<div style="font-size:12px;color:var(--ink-soft)">'+it.variant_title+'</div>':'')+'<div class="qty"><a href="#" data-ch="'+it.key+'" data-q="'+(it.quantity-1)+'">&minus;</a><span>'+it.quantity+'</span><a href="#" data-ch="'+it.key+'" data-q="'+(it.quantity+1)+'">+</a></div></div><div class="ci-right"><div>'+money(it.final_line_price)+'</div><a href="#" class="rm" data-ch="'+it.key+'" data-q="0" style="font-size:11px;text-transform:uppercase;letter-spacing:.06em;text-decoration:underline;color:var(--ink-soft)">Remove</a></div></div>';
      }).join('');
      if(foot){foot.style.display='block'; var st=$('#Subtotal'); if(st)st.textContent=money(cart.total_price);}
    });
  }
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if(!f)return; e.preventDefault();
    var fd=new FormData(f);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json()}).then(function(){refreshCart();openEl(cart);});
  });
  document.addEventListener('click',function(e){
    var ch=e.target.closest('[data-ch]'); if(!ch)return; e.preventDefault();
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:ch.getAttribute('data-ch'),quantity:+ch.getAttribute('data-q')})})
      .then(function(r){return r.json()}).then(refreshCart);
  });
  refreshCart();
})();
